export enum CommissionActivityKindEnum {
    NEW_COMMISSION,
    STORNO,
    RECONCILIATION,
}
